import { useState, useEffect } from "react";
import { SalarioInputCard } from "./components/SalarioInputCard";
import { SalarioResponseCard } from "./components/SalarioResponseCard";
import type { SalarioResultsType } from "./types";

export default function CalculadoraSalarioRealidadeBrasileira() {
  const [results, setResults] = useState<SalarioResultsType | null>(null);

  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = 'robots';
    metaTag.content = 'noindex, nofollow';
    document.head.appendChild(metaTag);

    return () => {
      const existingTag = document.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <>
      <SalarioInputCard setResults={setResults} />
      {results && <SalarioResponseCard results={results} />}
    </>
  );
}